import React, { Component } from 'react';
import {connect} from 'react-redux';
import {ProductLogo} from '../components/logo';
import {NavMenu} from '../components/menu';
import UserInfo from '../components/userInfo';

class Navigation extends Component {
  render() {
    const {videoFlag, handleLogoutClose} = this.props;
    return (
      <div className='mxvl nav-container'>
        <div className='nav-subcontainer'>
          <ProductLogo />
          {videoFlag && <UserInfo handleLogoutClose={handleLogoutClose}/>}
        </div>
        <NavMenu handleLogoutClose={handleLogoutClose}/>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    videoFlag: state.videoFlag,
  }
};

Navigation = connect(mapStateToProps)(Navigation);

export default Navigation;


// WEBPACK FOOTER //
// ./src/containers/Navigation.js